import { getPlatformSettings, updatePlatformSetting } from '@/services/ai/platformSettings.service'

export default {
	namespaced: true,
	state: {
		settingList: { data: [] },
		settingStatus: 'init',
		settingActionStatus: 'init',
	},
	getters: {
		getSettingList: (state) => state.settingList,
		getSettingStatus: (state) => state.settingStatus,
		getSettingActionStatus: (state) => state.settingActionStatus,
	},
	mutations: {
		SET_SETTING_LIST(state, val) {
			state.settingList = val
		},
		SET_SETTING_STATUS(state, val) {
			state.settingStatus = val
		},
		SET_SETTING_ACTION_STATUS(state, val) {
			state.settingActionStatus = val
		},
	},
	actions: {
		async fetchSettings({ commit }) {
			commit('SET_SETTING_STATUS', 'pending')
			try {
				const { data } = await getPlatformSettings()
				commit('SET_SETTING_LIST', data)
				commit('SET_SETTING_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_SETTING_STATUS', 'init')
				throw error
			}
		},
		async toggleSetting({ commit }, { key, value }) {
			commit('SET_SETTING_ACTION_STATUS', 'pending')
			try {
				const { data } = await updatePlatformSetting(key, value)
				commit('SET_SETTING_ACTION_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_SETTING_ACTION_STATUS', 'init')
				throw error
			}
		},
		async updateSetting({ commit }, { key, value }) {
			commit('SET_SETTING_ACTION_STATUS', 'pending')
			try {
				const { data } = await updatePlatformSetting(key, value)
				commit('SET_SETTING_ACTION_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_SETTING_ACTION_STATUS', 'init')
				throw error
			}
		},
	},
}
